$( ->

  # JOBS INDEX POST LATER PROMPT

  $(document).on 'click', '#post-later-modal .modal-footer button.submit-form', ->
    job_id = $('a#post-later-link').data('job-id')
    post_later_date = $('#post-later-modal .modal-body input#job_post_later_date').val()

    $.ajax
      url: "/manage/jobs/#{job_id}"
      type: 'POST'
      data:
        _method: 'put'
        job:
          activate_at: post_later_date
          status: 'draft'
      success: (data) ->
        $('#post-later-modal').addClass('post-later-confirmed')
        $('#post-later-modal .modal-header .modal-title').html("Job Post Scheduled")
        $('#post-later-modal .modal-body').html("<p>Success! Your job will be posted on #{post_later_date}.</p>")
        $('#post-later-modal .modal-footer button.btn-default').html("Close")
        $('#post-later-modal .modal-footer button.btn-primary.submit-form').remove()

        $("div#job_#{job_id}").remove()


  $(document).on 'click', '#post-later-modal:not(.post-later-confirmed) button.close', ->
    $('#referral-overlay-link').click()

  $(document).on 'click', '#post-later-modal:not(.post-later-confirmed) button.btn.btn-default', ->
    $('#referral-overlay-link').click()
)
